import { render, staticRenderFns } from "./homeTabPage.vue?vue&type=template&id=818c8de6&scoped=true"
import script from "./homeTabPage.vue?vue&type=script&lang=js"
export * from "./homeTabPage.vue?vue&type=script&lang=js"
import style0 from "./homeTabPage.vue?vue&type=style&index=0&id=818c8de6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "818c8de6",
  null
  
)

export default component.exports